import {
  MedicalDocumentType,
  MedicalDocument,
  GroupedMedicalDocuments
} from './model';
import { groupBy, valueOfEnum } from '@ianesthesie-kit/core';
import {
  BaseEntityService,
  ListApiResponse,
  QueryFilters,
  unwrapApiErrorDetails
} from '@ianesthesie-kit/services';
import axios, { AxiosResponse } from 'axios';

export class MedicalDocumentService extends BaseEntityService<MedicalDocument> {
  private static readonly INSTANCE: MedicalDocumentService =
    new MedicalDocumentService();

  private constructor() {
    super('/bff/patient/document');
  }

  public static getInstance(): MedicalDocumentService {
    return this.INSTANCE;
  }

  public fetchGroupedByType(
    filters?: QueryFilters
  ): Promise<GroupedMedicalDocuments> {
    return this.fetchAll(filters)
      .then((resp) => resp.data)
      .then((data) => groupBy(data, 'type'));
  }

  upload(
    document: Partial<MedicalDocument>,
    files?: File[],
    onUploadProgress?: (e: ProgressEvent) => void
  ): Promise<ListApiResponse<MedicalDocument>> {
    const formData = new FormData();
    const doc = {
      id: document.id,
      type: document.type,
      date: document.date,
      mediaIds: document.media?.map((d) => d.id)
    };
    if (!document.pending) {
      formData.append('document', JSON.stringify(doc));
    }
    files?.forEach((f) => {
      formData.append('files', f);
    });

    let url = this.getUrl();
    if (document.pending) {
      url += `/${document.id}/media`;
    }

    return axios
      .post<ListApiResponse<MedicalDocument>>(url, formData, {
        onUploadProgress
      })
      .then((response: AxiosResponse<ListApiResponse<MedicalDocument>>) => ({
        ...response.data,
        data: response.data.data.map((d) => this.transformResponseEntity(d))
      }))
      .catch((err) => {
        // todo handle error
        // todo sentry
        throw unwrapApiErrorDetails(err) || err;
      });
  }

  protected transformResponseEntity(data: any): MedicalDocument {
    return {
      ...super.transformResponseEntity(data),
      type: valueOfEnum(data.type, MedicalDocumentType, {
        throwIfNotFound: true,
        caseSensitive: false
      })!
    };
  }
}
